import api, { adminApi } from "./api";

export const getRiderServiceConfigsApi = async (params) => {
  const { data } = await api.get("/api/v1/rider-service-config", { params });
  return data;
};

export const getRiderListApi = async () => {
  const res = await adminApi.get("/api/v1/rider/list");
  return res.data;
};

export const getRiderByIdApi = async (riderId) => {
  const res = await adminApi.get(`/api/v1/rider/${riderId}`);
  return res.data;
};

export const updateRiderStatusApi = async (riderId, status) => {
  const res = await adminApi.put(`/api/v1/rider/${riderId}/status`, { status });
  return res.data;
};

export const approveRiderApi = async (riderId, payload) => {
  const res = await adminApi.put(`/api/v1/rider/${riderId}/approve`, payload);
  return res.data;
};

export const rejectRiderApi = async (riderId, payload) => {
  const res = await adminApi.put(`/api/v1/rider/${riderId}/reject`, payload);
  return res.data;
};

export const updateRiderVehicleServicesApi = async (riderId, payload) => {
  const res = await adminApi.put(`/api/v1/rider/${riderId}/vehicle-services`, payload);
  return res.data;
};
